import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20minimalist%20editorial%20flatlay%20of%20contemporary%20fashion%20items%20including%20premium%20leather%20sneakers%2C%20folded%20organic%20cotton%20hoodie%2C%20vintage%20wash%20denim%20jacket%2C%20and%20minimalist%20accessories%20arranged%20artfully%20on%20a%20warm%20sand%20colored%20linen%20backdrop%20with%20golden%20hour%20sunlight%20casting%20soft%20shadows%2C%20magazine%20editorial%20aesthetic%2C%20elevated%20composition%2C%20high%20detail%2C%20organic%20texture&width=1600&height=900&seq=itaobuy-hero-v2&orientation=landscape"
          alt="Itaobuy Spreadsheet prodotti moda"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-foreground-950/60"></div>

      <div className="relative z-10 w-full text-center px-4">
        <h2 className="font-label text-sm md:text-base uppercase tracking-[0.3em] text-background-50/70 mb-4">
          Database Aggiornato 2026
        </h2>
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-[1.05] mb-5 max-w-3xl mx-auto">
          {t('hero.title')}
        </h1>
        <p className="text-background-50/80 text-base md:text-lg max-w-xl mx-auto mb-8 font-light">
          {t('hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 hover:bg-background-50/25 transition-all"
          >
            {t('hero.cta_sheet')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600 transition-all"
          >
            {t('hero.cta_buy')}
          </a>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full overflow-hidden pointer-events-none select-none">
        <p className="font-heading text-[5rem] md:text-[9rem] font-black text-background-50/5 leading-none whitespace-nowrap text-center pb-2">
          ITAOBUY SHEET
        </p>
      </div>
    </section>
  );
}